import React from "react";
import PropTypes from "prop-types";
import GenericContactTable from "../../../../../../../components/ContactsTable/GenericContactsTable";
import { contactRoles } from "../../../config/buildingModalConfig";
import { useSelector, useDispatch } from "react-redux";
import {
  selectedSelectedBuildingContacts,
  setSelectedBuildingContact,
  clearSelectedBuildingContact,
} from "../../../../../../../redux/buildings/selectedBuildingContactSlice";
import useBuildingContacts from "../../../hooks/useBuildingContacts";

const BuildingContactTable = ({ isEditMode, onAddNew, onRowClick }) => {
  const selected = useSelector((state) => state.selectedBuilding);
  const buildingId = selected?.buildingID;
  const selectedContact = useSelector(selectedSelectedBuildingContacts);
  const dispatch = useDispatch();

  const onSelectContact = (contact) => {
    if (selectedContact && selectedContact.contactID === contact.contactID) {
      dispatch(clearSelectedBuildingContact());
    } else {
      dispatch(setSelectedBuildingContact(contact));
    }
  };

  return (
    <GenericContactTable
      isEditMode={isEditMode}
      onAddNew={onAddNew}
      onRowClick={onRowClick}
      onSelectContact={onSelectContact}
      rolesConfig={contactRoles}
      useContactsHook={useBuildingContacts}
      entityId={buildingId}
      selectedContact={selectedContact}
    />
  );
};

BuildingContactTable.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onAddNew: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default BuildingContactTable;
